import styled from 'styled-components';
import { Vehicle } from '../../types/vehicle';

const LabelWrapper = styled.div`
  position: absolute;
  top: -10px;
  left: -8px;
`;

const ReserveLabelComponent = styled.div<{ bg: string }>`
  height: 18px;
  color: #fff;
  display: flex;
  padding: 0 8px;
  width: fit-content;
  align-items: center;
  justify-content: center;
  background: ${props => props.bg};
  font-size: 10px;
  font-weight: 700;
`;

const reserveMetConfig = {
  bg: '#479747',
  label: 'Reserve Met'
};

const reserveNotMetConfig = {
  bg: '#CA8D57',
  label: 'Reserve Not Met'
};

export const ReserveLabel = ({ item: vehicle }: any) => {
  console.log(vehicle.reserve_price_set, 'vehicle.reserve_price_set');
  if (!vehicle.reserve_price_set) {
    return null;
  }

  const { bg, label } = vehicle.reserve_price_met ? reserveMetConfig : reserveNotMetConfig;

  return (
    <LabelWrapper>
      <ReserveLabelComponent bg={bg}>{label}</ReserveLabelComponent>
    </LabelWrapper>
  );
};
